<template>
  <div class="py-8">
    <router-link :to="taskChecklistUrl" class="flex items-center justify-start px-2 text-gray-700">
      <vue-feather type="chevron-left" class="h-8" />
      <span class="text-sm font-semibold">Back</span>
    </router-link>
    <Card v-if="loaded" extra-classes="max-w-xl mx-auto" overflow="visible">
      <div class="flex items-center justify-between">
        <header class="font-bold text-lg">Edit Checklist Task</header>
        <TButton color="indigo" size="md" label="Update" @click="updateTask" />
      </div>

      <component
        :is="detailComponent"
        v-if="detailComponent"
        ref="checklistFormComp"
        :task="task"
        :assignable-users="assignableUsers"
      />

      <TButton
        v-if="task.checklist_taskable_type !== 'ChecklistOnboardingFormTask'"
        color="red"
        size="md"
        class="flex flex-row gap-2 mt-8"
        @click="showDelete = true"
        ><vue-feather type="trash" size="16" /> Delete</TButton
      >
    </Card>
    <Modal
      v-if="showDelete"
      ref="modal"
      title="Delete onboarding task"
      body="Are you sure you want to delete this onboarding task? Deleting an onboarding task is permanent and will delete any tasks already assigned to people on your team."
      action="Delete"
      action-color="red"
      @close-modal="showDelete = false"
      @handle-action="deleteChecklistTask"
    />
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import Modal from '../shared/Modal.vue';
import ChecklistOnboardingFormTask from './ChecklistOnboardingFormTask.vue';
import ChecklistEsignatureTask from './ChecklistEsignatureTask.vue';
import ChecklistBasicTask from './ChecklistBasicTask.vue';
import ChecklistEmbedTask from './ChecklistEmbedTask.vue';
import { Api } from '../../api/index.ts';
import { formatTeamUsersForSelect } from '../../utilities/api/team';
import ChecklistUploadTask from './ChecklistUploadTask.vue';

export default {
  components: {
    Card,
    Modal,
    ChecklistEsignatureTask,
  },
  data() {
    return {
      loaded: false,
      showDelete: false,
      task: {},
      assignableUsers: [],
    };
  },
  computed: {
    detailComponent() {
      if (this.task.checklist_taskable_type === 'ChecklistEsignatureTask') {
        return ChecklistEsignatureTask;
      } else if (this.task.checklist_taskable_type === 'ChecklistOnboardingFormTask') {
        return ChecklistOnboardingFormTask;
      } else if (this.task.checklist_taskable_type === 'ChecklistEmbedTask') {
        return ChecklistEmbedTask;
      } else if (this.task.checklist_taskable_type === 'ChecklistUploadTask') {
        return ChecklistUploadTask;
      } else {
        return ChecklistBasicTask;
      }
    },
    taskChecklistType() {
      return this.task?.task_checklist?.checklist_type;
    },
    taskChecklistUrl() {
      return `/settings/company/${this.taskChecklistType}_checklists/${this.task?.task_checklist?.id}/edit`;
    },
  },
  async mounted() {
    await this.fetchTask();
    await this.fetchAssignableUsers();
    this.loaded = true;
    document.body.classList.remove('lg:overflow-hidden');
    this.$store.commit('general/hideLocalLoadingSpinner');
  },
  methods: {
    updateTask() {
      if (this.$refs.checklistFormComp) {
        this.$refs.checklistFormComp.updateTask();
      }
    },
    async fetchTask() {
      const res = await fetch(
        `/api/task_checklists/${this.$route.params.checklistId}/checklist_tasks/${this.$route.params.id}`
      );
      const { record } = await res.json();
      this.task = {
        ...record,
      };
    },
    async fetchAssignableUsers() {
      const { team_members } = await Api.Team.listTeamUsers();
      const formatted = formatTeamUsersForSelect(team_members);

      this.assignableUsers = formatted;
    },
    async deleteChecklistTask() {
      const { status } = await Api.ChecklistTasks.deleteChecklistTask(this.task);

      const checklistType = this.task.task_checklist.checklist_type;

      if (status === 'success') {
        await this.$router.push(`/settings/company/${checklistType}_checklists/${this.task.task_checklist.id}/edit`);
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Task Deleted',
          alertDescription: 'Your onboarding task was successfully deleted.',
        });
      }
    },
  },
};
</script>

<style>
@reference "tailwindcss";
[data-classification='box'] .formulate-input-wrapper,
.formulate-input-group .formulate-input-wrapper {
  @apply flex flex-row items-center justify-start gap-2;
}

.formulate-input-wrapper .formulate-input-label:first-child {
  @apply font-bold;
}

.formulate-input-wrapper {
  @apply !mt-0 !mb-0 !my-0;
}

.formulate-input-element.formulate-input-element--textarea textarea,
.formulate-input-element.formulate-input-element--number input {
  width: 100%;
  max-width: 36rem;
  border-radius: 0.5rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
</style>
